import React from 'react'
import { useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './SettlePayment.css'
import { useTranslation } from "react-i18next";
import { fetchSettlePaymentHistory } from '../../../utils/apiClient';

const SettlePayment = () => {
  const { t } = useTranslation();

  const [offset, setOffset] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [settleList, setSettleList] = React.useState([]);

  const [search, setSearch] = React.useState('');

  useEffect(() => {
    const api = () => {
      const params = new URLSearchParams();
      params.append('offset', offset);
      if (search) {
        params.append('keyword', search);
      }

      fetchSettlePaymentHistory(params.toString())
        .then(response => response.json())
        .then(data => {
          if (data?.errors) {
            alert(Object.values(data.errors)[0]);
            return;
          }

          const payload = data?.data || data;
          setSettleList(payload?.settle_histories || []);
          setTotal(payload?.total ?? data?.total ?? 0);
        })
        .catch(error => {
          console.error(error);
        });
    }

    if (search == '') {
      api();
    } else {
      const timer = setTimeout(() => {
        api();
      }, 500)
  
      return () => clearTimeout(timer)
    }
  }, [offset, search]);


  const changeOffset = (offset) => {
    if (offset < 0) {
      offset = 0;
    }
    if (offset > total) {
      offset = Math.floor(total / 100) * 100;
    }
    setOffset(offset);
  }

  const CreateSettlePaymentHistoryList = () => {
    return settleList.map((settle, index) => {
      return <Tr key={index} settle={settle} />
    })
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="settle">
        <div className="settle-title">{t('settle_payment.title')}</div>
        <div className='clearfix'></div>
        <div className="settle-search">
          <table className="settle-search-table">
            <tbody>
              <tr>
                <td>
                  <input className="settle-search-input" type="text" placeholder={t('settle_payment.placeholder')} value={search} onChange={(e) => {setSearch(e.target.value);setOffset(0)}} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="settle-search-paging">
            <button className="settle-search-paging-prev-button settle-search-paging-button" onClick={() => changeOffset(offset - 100)}>{t('settle.prev')}</button>
            <div className="settle-search-paging-text">{offset + 1} - {offset + 100 > total ? total : offset + 100} / {total}</div>
            <button className="settle-search-paging-next-button settle-search-paging-button" onClick={() => changeOffset(offset + 100)}>{t('settle.next')}</button>
          </div>
        </div>
        <div className="settle-content">
          <div className="settle-content-table">
            <table className="settle-content-table">
              <thead>
                <tr>
                  <th>{t('settle.user')}</th>
                  <th>{t('settle.email')}</th>
                  <th>{t('settle.name')}</th>
                  <th>{t('settle.point')}</th>
                  <th>{t('settle.day')}</th>
                  <th>{t('settle_payment.code')}</th>
                </tr>
              </thead>
              <tbody>
                <CreateSettlePaymentHistoryList />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default SettlePayment